export default __webpack_public_path__ + "static/Dr. Said Abdou-d3c41dd68f23a4ef94858308c2cbe807.jpeg";